import { MERCHANT_NUMBER_RULES, MerchantNumberRule } from 'features/authorization/constants/merchantNumbers';

/**
 * El código de la aerolínea por su nombre. Con las reglas que se le pasen (las de la base, `useMerchantRules`); sin
 * ellas, la tabla fija, como la usan las funciones puras que no llegan a la base (`mappers`,
 * `authorizationCrossExpiryWarning`).
 */
export const resolveCarrierCodeFromOptionName = (
	optionName: string,
	rules: readonly MerchantNumberRule[] = MERCHANT_NUMBER_RULES,
): string | null => {
	const normalized = optionName.trim().toLowerCase();
	if (!normalized) return null;

	const exact = rules.find((rule) => rule.carrierName.toLowerCase() === normalized);
	if (exact) return exact.carrierCode;

	const partial = rules.find(
		(rule) =>
			normalized.includes(rule.carrierName.toLowerCase()) || rule.carrierName.toLowerCase().includes(normalized),
	);

	return partial?.carrierCode ?? null;
};
